// The product gallery no longer uses Swiper. The mobile carousel is a native
// CSS scroll-snap container, driven by the controller in
// snippets/product-media-gallery.liquid. The browser owns the gesture, so the
// gallery cannot be left holding a stale touch after the enlarged image viewer
// opens and closes.
//
// This custom element is kept so existing <media-gallery> markup and any code
// that queries for it keep working. It intentionally does nothing.
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {}
  );
}
